import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/customListField/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemField({ id, params }) {
  return request(`/customListField/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewField(params) {
  return request.post('/customListField', {
    data: params,
  });
}

export async function queryAddEditField(params) {
  return request.put('/customListField', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/customListField/${id}`, {});
}
